<div class="nested-menu">
    <div class="menu-section">
        <button type="button" *ngIf="!item.subMenuEleRef" mat-menu-item (click)="select(item)" (mouseenter)="closeOther()">{{
            item.title }}</button>
        <button type="button" *ngIf="item.subMenuEleRef" mat-menu-item #trigger="matMenuTrigger"
            [matMenuTriggerFor]="item.subMenuEleRef" (mouseenter)="closeOther(trigger)" (menuOpened)="menuOpened()"
            (click)="midMenuClick(item, trigger)">{{
            item.title }}</button>

        <mat-menu *ngIf="item.subCategories.length" #submenu="matMenu" panelClass="t" class="ig-nested-menu-item">
            <button type="button" *ngIf="!useNonLeafMenuClick" mat-menu-item all (click)="select('All')">All</button>
            <ng-container *ngFor="let sub of item.subCategories">
                <ig-nested-menu-item [item]="sub" [useNonLeafMenuClick]="useNonLeafMenuClick" (onClick)="select($event)"
                    (onNonLeafClick)="midMenuClick($event)"></ig-nested-menu-item>
            </ng-container>
        </mat-menu>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/nested.menu/nested.menu.item/nested.menu.item.component.html